/* Japanese initialisation for the jQuery UI date picker plugin. */
/* Written by Kentaro SATO (kentaro@ranvis.com). */
jQuery(function($){
	$.datepicker.regional['ja'] = {
		closeText: '閉じる',
		prevText: '&#x3c;前',
		nextText: '次&#x3e;',
		currentText: '今日',
		monthNames: ['1月','2月','3月','4月','5月','6月',
		'7月','8月','9月','10月','11月','12月'],
		monthNamesShort: ['1月','2月','3月','4月','5月','6月',
		'7月','8月','9月','10月','11月','12月'],
		dayNames: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
		dayNamesShort: ['日','月','火','水','木','金','土'],
		dayNamesMin: ['日','月','火','水','木','金','土'],
		dateFormat: 'yy/mm/dd', firstDay: 0,
		isRTL: false,
		yearSuffix: '年',
		showMonthAfterYear: true};
	$.datepicker.setDefaults($.datepicker.regional['ja']);
});


//////////////////
// WEBPACK FOOTER
// ./source/javascripts/vendor/admin/js/libs/ui/i18n/ui.datepicker-ja.js
// module id = 596
// module chunks = 7 8 9 10